export default {
  common: {
    labels: {
      onlyInstalled: "Tylko zainstalowane",
      showMore: "Pokaż więcej",
      showLess: "Pokaż mniej",
      reportDate: "Data raportu",
      reportTime: "Czas raportu",
      reportAtGlance: "Raport na pierwszy rzut oka",
      fleetStatus: "Status floty",
      fleetSize: "Wielkość floty",
      totalDevices: "Liczba urządzeń",
      addNewAlert: "Dodaj nowe powiadomienie",
      addNewRecepient: "Dodaj nowego odbiorcę",
      selectEVModel: "Wybierz model EV",
      selectHPModel: "Wybierz model HP",
      reRunAnalysis: "Ponowne wykonanie analizy",
      devicesWith: "Urządzenia z",
      logout: "Wyloguj",
      name: "Imię",
      email: "Email",
      nickname: "Pseudonim",
      openAsPage: "Otwórz jako strona",
      editDeviceDetails: "Edytuj szczegóły urządzenia",
      manageAlerts: "Zarządzaj powiadomieniami",
      noLocation: "Nie znaleziono lokalizacji dla tego urządzenia",
      selectDeviceToCompare: "Wybierz urządzenie do porównania",
      includeAmbientTemperature: "Uwzględnij temperaturę otoczenia",
      startDate: "Data rozpoczęcia",
      endDate: "Data zakończenia",
      thisFieldIsRequired: "To pole jest wymagane",
      mustBeLessThan50Characters: "Musie mieć mniej niż 50 znaków",
      numberHasToBeBetween0And100: "Liczba musi być między 0 a 100",
      timeOfDay: "Czas dnia",
      indicatesRequiredField: "Wskazuje pole wymagane",
      editDetails: "Edytuj szczegóły",
      noReportAvailable: "Nie ma dostępnych raportów dla żadnego tygodnia",
      noDataAvailable: "Brak dostępnych danych",
      resetView: "Resetuj widok",
      fleetOverview: "Przegląd floty",
      functionalLocation: "Lokalizacja funkcjonalna",
    },
    words: {
      total: "Całkowita",
      this: "To",
      all: "Wszystko",
      watchList: "Lista obserwowanych",
      schedule: "Harmonogram",
      client: "Klient",
      recepients: "Odbiorcy",
      more: "Więcej",
      devices: "Urządzenia",
      search: "Szukaj",
      reset: "Resetuj",
      save: "Zapisz",
      language: "Język",
      english: "Angielski",
      french: "Francuski",
      back: "Wstecz",
      clear: "Wyczyść",
      to: "do",
      standart: "Standard",
      commuter: "Dojazdowy",
      nonCommuter: "Niedojeżdżający",
      edit: "Edytuj",
      cancel: "Anuluj",
      saveAs: "Zapisz jako",
      alert: "Powiadomienie",
      last: "Ostatni",
      preferences: "Preferencje",
    },
    messages: {
      success: {
        deviceDetailsSaved: "Szczegóły urządzenia zapisane pomyślnie!",
        good: "Dobrze",
      },
      warnings: {
        temperatureError: "Błąd temperatury",
        temperatureInvestigationWarning: "Aktywa z powiadomieniem o temperaturze, które mogą wymagać zbadania",
        missedMessages: "Nieodebrane wiadomości",
        noCommunications: "Brak komunikacji",
      },
      errors: {},
      filter: {
        filterApplied: "Filtr zastosowany pomyślnie",
        filterRemoved: "Filtr usunięty pomyślnie",
        filterError: "Błąd podczas zastosowania filtru",
      },
    },
    measure: {
      kVA: "kVA",
      kW: "kW",
    },
    times: {
      days: {
        sunday: "Niedziela",
        monday: "Poniedziałek",
        tuesday: "Wtorek",
        wednesday: "Środa",
        thursday: "Czwartek",
        friday: "Piątek",
        saturday: "Sobota",
      },
      months: {
        january: "Styczeń",
        february: "Luty",
        march: "Marzec",
        april: "Kwiecień",
        may: "Maj",
        june: "Czerwiec",
        july: "Lipiec",
        august: "Sierpień",
        september: "Wrzesień",
        november: "Listopad",
        december: "Grudzień",
        jan: "Sty",
        feb: "Lut",
        mar: "Mar",
        apr: "Kwi",
        my: "Maj",
        jun: "Cze",
        jul: "Lip",
        aug: "Sie",
        sep: "Wrz",
        nov: "Lis",
        dec: "Gru",
      },
      time: {
        today: "Dzisiaj",
        second: "Sekunda",
        seconds: "Sekundy",
        minute: "Minuta",
        minutes: "Minuty",
        hr: "Godzina",
        hrs: "Godziny",
        day: "Dzień",
        days: "Dni",
        week: "Tydzień",
        weeks: "Tygodnie",
        month: "Miesiąc",
        months: "Miesiące",
        year: "Rok",
        years: "Lata",
        secondsAge: "Sekundy temu",
        minutesAge: "Minuty temu",
        hoursAgo: "Godziny temu",
        daysAgo: "Dni temu",
        weeksAgo: "Tygodnie temu",
        monthsAgo: "Miesiące temu",
        yearsAgo: "Lata temu",
        last24Hours: "Ostatnie 24 godziny",
        last7Days: "Ostatnie 7 dni",
        last28Days: "Ostatnie 28 dni",
        lastWeek: "Poprzedni tydzień",
        last4Weeks: "Ostatnie 4 tygodnie",
        last8Weeks: "Ostatnie 8 tygodni",
        last3Months: "Ostatnie 3 miesiące",
        last6Months: "Ostatnie 6 miesięcy",
        last1Year: "Ostatni rok",
        TwentyFourHours: "24 godziny",
        SevenDays: "7 dni",
        TwentyEightDays: "28 dni",
      },
    },
  },
  views: {
    Alerts: {},
    Analytics: {
      mainTitle: "Analiza",
      pageTitle: "Przegląd",
      charts: {
        totalPower: {
          title: "Całkowita Moc",
          xLabel: "Pojemność (kVA)",
          yLabel: "Oznaczenie czasowe",
          bottomLabelMaxCapacity: "Całkowita maksymalna pojemność",
          bottomLabelTotalCapacity: "Całkowicie wykorzystana pojemność",
        },
        issues: {
          title: "Problemy",
          xLabel: "Problemy",
          yLabel: "Liczba urządzeń",
          hAxis: {
            HasCapacityUnderLimit: {
              label: "Pojemność poniżej limitu",
              tooltip: "Aktywa z pojemnością mniejszą niż 15%",
            },
            HasCapacityOverLimit: {
              label: "Pojemność powyżej limitu",
              tooltip: "Aktywa z pojemnością większą niż 85%",
            },
            HasMissedMessages: {
              label: "Nieodebrane wiadomości",
              tooltip: "Aktywa z nieodebranymi wiadomościami",
            },
            HasImbalance: {
              label: "Nierównowaga faz",
              tooltip: "Aktywa z maksymalną nierównowagą > 90%",
            },
            HasCurrentOverLimit: {
              label: "Prąd powyżej limitu",
              tooltip: "Aktywa z prądem powyżej limitu",
            },
            HasLowBattery: {
              label: "Niski poziom baterii",
              tooltip: "Aktywa z niskim poziomem baterii",
            },
            HasNoPower: {
              label: "Brak zasilania",
              tooltip: "Aktywa bez zasilania",
            },
            HasTemperatureOutsideRange: {
              label: "Temperatura poza zakresem",
              tooltip: "Aktywa z temperaturą poza zakresem",
            },
            HasTemperatureOverLimit: {
              label: "Temperatura powyżej limitu",
              tooltip: "Aktywa z temperaturą powyżej limitu",
            },
            HasTemperatureSenseError: {
              label: "Alert temperatury",
              tooltip: "Aktywa z alertem temperatury",
            },
          },
        },
      },
      tables: {
        devices: {
          title: "Urządzenia",
          columns: {
            id: "ID urządzenia",
            type: "Typ monitora",
            t_name: "Nazwa transformatora",
            t_size: "Rozmiar transformatora",
            capacity: {
              text: "Pojemność",
              tooltip:
                "% całkowicie dostępnej pojemności w użyciu. (Całkowity prąd średni * 230/1000) / Moc znamionowa (%)",
            },
            power: {
              text: "Całkowita Moc",
              tooltip: "Całkowite zsumowane maksymalne pomiary mocy wszystkich faz wykonane w określonym okresie.",
            },
            l_message: "Ostatnia wiadomość",
          },
        },
      },
    },
    Asset: {
      deviceDetails: {
        transformerName: {
          label: "Nazwa transformatora",
        },
        transformerNo: {
          label: "Numer transformatora",
        },
        transformerSize: {
          label: "Rozmiar transformatora",
        },
        assetId: {
          label: "ID aktywa",
        },
        deviceStatus: {
          label: "Status urządzenia",
        },
        deviceVoltage: {
          label: "Napięcie urządzenia",
        },
        installationDate: {
          label: "Data instalacji",
        },
        connectedMPRNs: {
          label: "Podłączone MPRN-y",
        },
        commuterArea: {
          label: "Obszar podmiejski",
        },
      },
      latestMessage: {
        title: "Ostatnia wiadomość",
        currentPH1: {
          label: "Prąd fazowy 1",
          suffix: "A",
          helptext: "(Med./Max)",
        },
        currentPH2: {
          label: "Prąd fazowy 2",
          suffix: "A",
          helptext: "(Med./Max)",
        },
        currentPH3: {
          label: "Prąd fazowy 3",
          suffix: "A",
          helptext: "(Med./Max)",
        },
        temperature: {
          label: "Temperatura",
          suffix: "°C",
          helptext: "(Med./Max)",
        },
      },
      calculatedReadings: {
        title: "Obliczone odczyty",
        totalPower: {
          label: "Całkowita moc",
          suffix: "kVA",
        },
        capacity: {
          label: "Pojemność",
          suffix: "%",
        },
        imbalance: {
          label: "Nierównowaga",
          suffix: "%",
        },
        utilization: {
          label: "Wykorzystanie",
          suffix: "%",
        },
      },
      tabs: {
        charts: {
          label: "Wykresy",
        },
        messages: {
          label: "Wiadomości",
        },
        evAnalysis: {
          label: "Analiza EV",
        },
        hpAnalysis: {
          label: "Analiza HP",
        },
      },
      charts: {
        chartConfig1: {
          title: "Wybierz urządzenie do porównania",
          temp: {
            label: "Temperatura (°C)",
            xAxis: "Oznaczenie czasowe",
            yAxis: "Temperatura (°C)",
          },
          diff: {
            label: "Temperatura (°C)",
            xAxis: "Oznaczenie czasowe",
            yAxis: "Temperatura",
          },
          imbalance: {
            label: "Nierównowaga i prądy średnie (A)",
            labelDailyStats: "Nierównowaga i prądy (A)",
            xAxis: "Oznaczenie czasowe",
            yAxis: "Maks. obciążenie (A)",
            yBarAxis: "Nierównowaga (%)",
          },
          totalPower: {
            label: "Całkowita moc i prądy średnie (A)",
            labelDailyStats: "Całkowita moc i prądy (A)",
            xAxis: "Oznaczenie czasowe",
            yAxis: "Maks. obciążenie (A)",
            yBarAxis: "Całkowita moc (kVA)",
          },
          imbalanceMax: {
            label: "Nierównowaga i maksymalne prądy (A)",
            xAxis: "Oznaczenie czasowe",
            yAxis: "Maks. obciążenie",
            yBarAxis: "Nierównowaga",
          },
          totalPowerMax: {
            label: "Całkowita moc i maksymalne prądy (A)",
            xAxis: "Oznaczenie czasowe",
            yAxis: "Maks. obciążenie (A)",
            yBarAxis: "Całkowita moc (kVA)",
          },
        },
      },
      tables: {
        messages: {
          columns: {
            seqNo: {
              text: "Nr sekwencyjny",
            },
            messageTime: {
              text: "Czas wiadomości",
            },
            missedMessage: {
              text: "Nieodebrana wiadomość",
            },
            lqi: {
              text: "LQI",
            },
            medCurrentPH1: {
              text: "Średni prąd fazowy 1",
              suffix: "A",
            },
            maxCurrentPH1: {
              text: "Maks. prąd fazowy 1",
              suffix: "A",
            },
            medCurrentPH2: {
              text: "Średni prąd fazowy 2",
              suffix: "A",
            },
            maxCurrentPH2: {
              text: "Maks. prąd fazowy 2",
              suffix: "A",
            },
            medCurrentPH3: {
              text: "Średni prąd fazowy 3",
              suffix: "A",
            },
            maxCurrentPH3: {
              text: "Maks. prąd fazowy 3",
              suffix: "A",
            },
            maxTemp: {
              text: "Maks. temperatura",
              suffix: "°C",
            },
            medTemp: {
              text: "Średnia temperatura",
              suffix: "°C",
            },
            capacity: {
              text: "Pojemność",
              suffix: "%",
              tooltip: "% całkowicie dostępnej pojemności w użyciu. (Średni prąd * 230/1000) / Moc znamionowa (%)",
            },
            imbalance: {
              text: "Nierównowaga",
              suffix: "%",
              tooltip:
                "Nierównowaga prądowa między fazami. Maksymalna różnica między fazą a średnim prądem / średni prąd (%) *tylko dla 3 faz",
            },
          },
        },
      },
    },
    Assets: {
      pageTitle: "Przegląd urządzeń",
      deviceCoverage: "Sprawdź pokrycie urządzeń",
      charts: {
        capacity: {
          title: "Pojemność",
          tooltip:
            "Analiza pojemności mierzy ilość wykorzystanej pojemności w każdym transformatorze i dzieli ją na nadmiernie wykorzystaną, normalną lub niewydajną.",
          header: {
            capacity: "Pojemność",
            numberOfDevices: "Liczba urządzeń",
          },
          data: {
            underperforming: {
              text: "Niewydajne",
              message: "Urządzenia poniżej limitu prądu - Mniej niż 15% pojemności",
            },
            normal: {
              text: "Normalne",
              message: "Urządzenia optymalnie wykorzystane - Pomiędzy 15% a 85% pojemności",
            },
            overutilised: {
              text: "Nadmiernie wykorzystane",
              message: "Urządzenia przekraczające limit prądu - Powyżej 85% pojemności",
            },
          },
        },
        imbalance: {
          title: "Nierównowaga",
          tooltip:
            "Nierównowaga mierzy stopień nierównowagi między wszystkimi 3 fazami używanymi w każdym transformatorze i dzieli na nierównowagę lub normalne.",
          header: {
            imbalanceStatus: "Status nierównowagi",
            numberOfDevices: "Liczba urządzeń",
          },
          data: {
            normal: {
              label: "Normalne",
              message: "Urządzenia bez nierównowagi.",
            },
            imbalance: {
              label: "Nierównowaga",
              message: "Urządzenia z nierównowagą.",
            },
          },
        },
        powerChange: {
          title: "Zmiana mocy",
          tooltip:
            "Zmiana mocy mierzy ilość zmian mocy w każdym transformatorze i dzieli ją na nieprawidłową lub normalną.",
          header: {
            powerChangeStatus: "Status zmiany mocy",
            numberOfDevices: "Liczba urządzeń",
          },
          data: {
            normal: {
              label: "Normalne",
              message: "Urządzenia bez nieprawidłowych zmian mocy.",
            },
            abnormal: {
              label: "Nietypowe",
              message: "Urządzenia z nieprawidłowymi zmianami mocy.",
            },
          },
        },
        batteryStatus: {
          title: "Stan baterii",
          tooltip: "Wyświetla stan baterii wszystkich urządzeń i dzieli na wysoki, niski lub nieznany.",
          header: {
            batteryStatus: "Stan baterii",
            numberOfDevices: "Liczba urządzeń",
          },
          data: {
            highBattery: {
              label: "Wysoka bateria",
              message: "Urządzenia z wysokim poziomem baterii.",
            },
            lowBattery: {
              label: "Niska bateria",
              message: "Urządzenia z niskim poziomem baterii.",
            },
            unknownBattery: {
              label: "Nieznana bateria",
              message: "Urządzenia z nieznanym poziomem baterii.",
            },
          },
        },
        devicesCommunication: {
          title: "Komunikacja urządzeń",
          tooltip:
            "Wyświetla komunikację wszystkich urządzeń i dzieli na przekazane, brak komunikacji lub brak odebranych wiadomości.",
          header: {
            connectivity: "Połączenie",
            numberOfDevices: "Liczba urządzeń",
          },
          data: {
            communicated: {
              label: "Przekazane",
              message: "Urządzenia bez brakujących wiadomości",
            },
            noCommunications: {
              label: "Brak komunikacji",
              message: "Urządzenia, które nie komunikowały się w ciągu ostatnich 24 godzin",
            },
            missedMessages: {
              label: "Brak odebranych wiadomości",
              message: "Urządzenia z brakującymi wiadomościami",
            },
          },
        },
        devicesStatus: {
          title: "Status urządzeń",
          tooltip:
            "Wyświetla statusy/problemów wszystkich urządzeń i dzieli na brak problemu, problem nierównowagi, temperaturę poza zakresem, przekroczenie limitu prądu, problem z komunikacją, problem z zasilaniem, problem z czujnikiem temperatury, przekroczenie limitu temperatury lub problem z baterią.",
          header: {
            deviceStatus: "Status urządzenia",
            numberOfDevices: "Liczba urządzeń",
          },
          data: {
            noIssue: {
              label: "Brak problemu",
              message: "Urządzenia bez problemów.",
            },
            phaseImbalance: {
              label: "Nierównowaga fazowa",
              message: "Urządzenia z maksymalną nierównowagą > 90%",
            },
            temperatureAlert: {
              label: "Alarm temperatury",
              message: "Urządzenia z alarmem temperatury, które mogą wymagać zbadania",
            },
            currentOverlimit: {
              label: "Przekroczenie limitu prądu",
              message: "Urządzenia z przekroczeniem limitu prądu.",
            },
            communicationProblem: {
              label: "Problem komunikacji",
              message: "Urządzenia z problemem komunikacji.",
            },
            noPower: {
              label: "Brak zasilania",
              message: "Urządzenia z problemem zasilania.",
            },
            lowBattery: {
              label: "Niska bateria",
              message: "Urządzenia z problemami z baterią.",
            },
          },
        },
      },
      tables: {
        devices: {
          title: "",
          filters: {
            primary: {},
            secondary: {
              list_checkbox: {
                label: "Typ transformatora",
              },
              flags: {
                temperatureOverlimit: {
                  label: "Przekroczenie temperatury",
                },
                currentOverlimit: {
                  label: "Przekroczenie limitu prądu",
                },
              },
              range: {
                transformerSize: {
                  label: "Rozmiar transformatora",
                },
                maxCurrentPH1: {
                  label: "Maksymalny prąd PH1",
                },
                maxCurrentPH2: {
                  label: "Maksymalny prąd PH2",
                },
                maxCurrentPH3: {
                  label: "Maksymalny prąd PH3",
                },
                maxTemperature: {
                  label: "Maksymalna temperatura",
                },
              },
            },
          },
          columns: {
            deviceId: {
              text: "ID urządzenia",
            },
            monitorType: {
              text: "Typ monitora",
            },
            deviceName: {
              text: "Nazwa",
            },
            powerRating: {
              text: "Rozmiar transformatora",
            },
            totalPower: {
              text: "Całkowita moc",
              tooltip: "Całkowita zsumowana maksymalna moc wszystkich faz mierzona w okresie.",
            },
            maxCapacity: {
              text: "Maks. pojemność (%)",
              tooltip:
                "% całkowicie dostępnej pojemności w użyciu. (Całkowity maks. prąd * 230/1000) / Moc znamionowa (%)",
            },
            maxImbalance: {
              text: "Maks. nierównowaga (%)",
              tooltip:
                "Nierównowaga prądowa między fazami. Maksymalna różnica między fazą a średnim prądem / Średni prąd (%) * dla 3 faz",
            },
            current0Max: {
              text: "Maks. prąd PH1-PH2-PH3",
            },
            maxTemperature: {
              text: "Maks. temp.",
            },
            isCommuterArea: {
              text: "Obszar dojazdowy",
            },
            isWatchlisted: {
              text: "",
            },
            moreActions: {
              text: "",
              labels: ["Edytuj szczegóły"],
            },
          },
        },
      },
    },
    AssetSnapshotView: {},
    CoverageChecker: {},
    Device: {},
    DeviceCoverage: {},
    DeviceHome: {},
    Error: {},

    EVModelling: {
      charts: {
        maxEVSupported: {
          title: "Maksymalna obsługiwana liczba pojazdów elektrycznych (EV)",
          labels: {
            maxEVs: "Maksymalna liczba EV",
            numberOfDevices: "Liczba urządzeń",
          },
        },
        maxHPSupported: {
          title: "Maksymalna obsługiwana moc (HP)",
          labels: {
            maxHP: "Maksymalna moc (HP)",
            numberOfDevices: "Liczba urządzeń",
          },
        },
        firstYearOverCapacity: {
          title: "Pierwszy rok przekroczenia pojemności",
          labels: {
            xLabel: "Pierwszy rok problemu",
            yLabel: "Liczba urządzeń",
          },
        },
      },
      tables: {
        deviceEVMTable: {
          title: "",
          columns: {
            deviceId: {
              text: "ID urządzenia",
            },
            maxEVs: {
              text: "Maks. liczba EV",
            },
            maxEVHour: {
              text: "Godzina maks. liczby EV",
            },
            firstYearOverCapacity: {
              text: "Pierwszy rok przekroczenia pojemności (łącznie)",
            },
            maxLoadDay: {
              text: "Maks. obciążenie (dzień)",
            },
            minHeadroom: {
              text: "Min. margines",
            },
            maxLoad: {
              text: "Maks. obciążenie",
            },
            maxLoadHour: {
              text: "Godzina maks. obciążenia",
            },
          },
        },
      },
    },
    Home: {},
    HPModelling: {},
    Journey: {},
    Journeys: {},
    Location: {},
    LocationList: {},
    PoiReport: {},
    PowerdataAlerts: {
      title: "",
      tabs: {
        activeAlerts: {
          label: "Aktywne Alerty",
        },
        manageAlerts: {
          label: "Zarządzaj Alertami",
        },
      },
      alert: {
        alarm: {
          label: "Alarm",
        },
        maxCurrentPH1: {
          label: "Maks. Prąd Faza 1",
        },
        medCurrentPH1: {
          label: "Średni Prąd Faza 1",
        },
        maxCurrentPH2: {
          label: "Maks. Prąd Faza 2",
        },
        medCurrentPH2: {
          label: "Średni Prąd Faza 2",
        },
        maxCurrentPH3: {
          label: "Maks. Prąd Faza 3",
        },
        medCurrentPH3: {
          label: "Średni Prąd Faza 3",
        },
        maxTemperature: {
          label: "Maks. Temperatura",
        },
        medTemperature: {
          label: "Średnia Temperatura",
        },
        imbalance: {
          label: "Niezbilansowanie",
        },
        totalPower: {
          label: "Całkowita Moc",
        },
      },
      tables: {
        alerts: {
          columns: {
            alertId: {
              text: "ID Alerty",
            },
            deviceId: {
              text: "ID Urządzenia",
            },
            deviceType: {
              text: "Typ Urządzenia",
            },
            triggerField: {
              text: "Pole Wyzwalające",
            },
            triggerValue: {
              text: "Wartość Wyzwalająca",
            },
            triggerOperator: {
              text: "Operator Wyzwalający",
            },
            moreActions: {
              text: "",
              labels: ["Zarządzaj Odbiorcami", "Edytuj Szczegóły", "Usuń"],
            },
          },
        },
        activeAlerts: {
          columns: {
            alertId: {
              text: "ID Alerty",
            },
            deviceId: {
              text: "ID Urządzenia",
            },
            fullName: {
              text: "Imię i Nazwisko",
            },
            deviceType: {
              text: "Typ Urządzenia",
            },
            triggerField: {
              text: "Pole Wyzwalające",
            },
            triggerValue: {
              text: "Wartość Wyzwalająca",
            },
            actualValue: {
              text: "Aktualna Wartość",
            },
            triggerDate: {
              text: "Data Wyzwalania",
            },
          },
        },
      },
    },
    PowerdataReports: {
      header: {},
    },
    PowerdataReportView: {},
    Profile: {
      userInformation: {
        title: "Informacje o użytkowniku",
      },
      preferences: {
        language: "Preferencje językowe",
        theme: "Preferencje motywu",
      },
      managePreferences: {
        title: "Zarządzaj preferencjami",
        defaultTab: "Domyślna karta",
        manageSections: "Zarządzaj sekcjami",
        arrangeSections: "Ustaw sekcje",
        manageScavengerTabs: "Zarządzaj kartami Scavenger",
        manageScavengerAlerts: "Scavenger Alertami",
        manageSentinelTabs: "Zarządzaj kartami Sentinel",
        manageSentinelAlerts: "Sentinel Alertami",
        manageEventNotifications: "Wydarzenia Scavenger", 
      },
    },
    Reports: {},
    ScavengerAsset: {},
    ScavengerAssets: {},
    ScavengerOverview: {
      title: "Forbhreathnú",
      tabs: {
        all: {
          label: "Urządzenia) ",
        },
        nz: {
          label: "Urządzenia z ",
        },
        pq: {
          label: "Urządzenia z ",
        },
        th: {
          label: "Urządzenia z ",
        },
        h2: {
          label: "Urządzenia z ",
        },
      },
    },
    ScavengerH2: {
      title: "Przegląd",
      tabs: {
        alarm: {
          label: "Alarm",
        },
        caution: {
          label: "Ostrzeżenie",
        },
        checkDevice: {
          label: "Sprawdź urządzenie",
        },
        noIssues: {
          label: "Brak problemów",
        },
      },
      tables: {
        devices: {
          columns: {
            deviceId: {
              text: "ID",
            },
            h2Level: {
              text: "Poziom H₂",
            },
            xfmrId: {
              text: "ID XFMR",
            },
            site: {
              text: "LOKALIZACJA",
            },
            oilType: {
              text: "TYP OLEJU",
            },
            opMode: {
              text: "TRYB PRACY",
            },
            lastReading: {
              text: "OSTATNIE ODCZYTANIE",
            },
          },
        },
      },
    },
    ScavengerH2Details: {
      deviceDetails: {
        site: {
          label: "Lokalizacja",
        },
        xfmrId: {
          label: "ID XFMR",
        },
        serialNumber: {
          label: "Numer seryjny",
        },
        opMode: {
          label: "Tryb pracy",
        },
        oilType: {
          label: "Typ oleju",
        },
        deviceStatus: {
          label: "Status urządzenia",
        },
        lastStatusUpdate: {
          label: "Data instalacji",
        },
        alarmLimit: {
          label: "Limit alarmu",
        },
        cautionLimit: {
          label: "Limit ostrzeżenia",
        },
        sensorType: {
          label: "Typ czujnika",
        },
        sensorLocation: {
          label: "Lokalizacja czujnika",
        },
      },
      latestMessage: {
        title: "Najnowsza wiadomość",
        labels: {
          h2Level: {
            label: "Poziom H₂",
          },
          oilTemperature: {
            label: "Temperatura oleju",
          },
          pcbTemperature: {
            label: "Temperatura PCB",
          },
        },
      },
      tabs: {
        charts: {
          label: "Wykresy",
        },
        messages: {
          label: "Wiadomości",
        },
      },
      charts: {
        h2Charts: {
          h2LevelandOilTemperature: {
            label: "Poziom wodoru (ppm)",
            label_daily_stats: "Poziom wodoru (ppm)",
            xAxis: "Oznaczenie czasu",
            yAxis: "Poziom wodoru (ppm)",
            yLineAxis: "Temperatura oleju (°C)",
            yLabel: "Poziom wodoru",
            hydrogen: "Wodór",
            oilTemperature: "Temperatura oleju",
          },
          liquidTemperature: {
            label: "Temperatura cieczy",
            label_daily_stats: "Temperatura cieczy",
            xAxis: "Oznaczenie czasu",
            yAxis: "Temperatura cieczy",
            liquidTemperature: "Temperatura cieczy",
          },
          rateOfChange: {
            label: "Tempo zmiany",
            label_daily_stats: "Tempo zmiany",
            xAxis: "Oznaczenie czasu",
            yAxis: "Tempo zmiany",
          },
        },
        h2LongerPeriodCharts: {
          h2LevelandOilTemperature: {
            label: "Poziom wodoru (ppm) i temperatura cieczy (°C)",
            label_daily_stats: "Poziom wodoru (ppm) i temperatura cieczy (°C)",
            xAxis: "Znacznik czasu",
            yAxis: "Poziom wodoru (ppm) i temperatura cieczy (°C)",
            yLineAxis: "Temperatura cieczy (°C)",
            yLabel: "Poziom wodoru i temperatura cieczy",
            hydrogen: "Wodór",
            oilTemperature: "Temperatura cieczy",
          },
        },
      },
      tables: {
        messages: {
          seqNo: {
            text: "Numer sekwencji",
          },
          messageTime: {
            text: "Czas wiadomości",
          },
          h2Level: {
            text: "Poziom H₂",
          },
          oilTemperature: {
            text: "Temperatura oleju",
          },
          pcbTemperature: {
            text: "Temperatura PCB",
          },
        },
      },
    },
    Snapshot: {},
  },
  components: {
    AlertsTemplate: {
      labels: {
        deviceType: "Typ urządzenia",
        triggerField: "Pole wyzwalacza",
        triggerValue: "Wartość wyzwalacza",
        device: "Urządzenie",
        triggerOperator: "Operator wyzwalacza",
      },
    },
    ScavengerAlertsTemplate: {
      labels: {
        triggerField: "Pole wyzwalacza",
        triggerValue: "Wartość wyzwalacza",
        device: "Urządzenie",
        xfmrId: "ID XFMR",
        deviceId: "ID urządzenia",
        triggerOperator: "Operator wyzwalacza",
      },
    },
    AreaChartVT: {},
    AssetSnapshot: {},
    ColumnChartVT: {},
    ComboChart: {},
    ComboChartVT: {},
    DataTableVT: {},
    DaysSelector: {},
    DialogVT: {
      contactVT: "Proszę skontaktuj się z VT...",
      desc: "Masz ograniczony dostęp do funkcji dostępnych w aplikacji. Skontaktuj się z VT, aby dowiedzieć się więcej o oferowanych funkcjach.",
    },
    DiffAreaChart: {},
    DiffAreaChartVT: {},
    DiffChart: {},
    DiffColumnChartVT: {},
    DistributionBarVT: {},
    EditAssetDetails: {},
    EditLocationDetails: {},
    Error: {},
    EVModelDetails: {},
    EVModelEditDetails: {
      labels: {
        selectModel: "Wybierz model",
        selectDayType: "Wybierz typ dnia",
        useCommuterStatus: "Użyj statusu dojazdowca",
        mostRecentWeekday: "Najnowszy dzień roboczy",
        mostRecentWeekdayTooltip: "* Dla których dostępne są dane wiadomości z 24 godzin",
        maxAnnualLoadDay: "Maksymalny dzień obciążenia rocznego",
        evModelDetails: "Szczegóły modelu EV",
        chooseModelName: "Wybierz nazwę modelu",
        modelName: "*Nazwa modelu",
        indicatesRequiredField: "*Wskazuje wymagane pole",
        chargeRateWeekday: "Wskaźnik ładowania (dzień roboczy)",
        chargeDurationWeekday: "Czas ładowania, dzień roboczy (godz.)",
        chargeDurationWeekend: "Czas ładowania, weekend (godz.)",
        ratioOfHigh1: "Stosunek wysokich (7 kW) do niskich (3 kW) ładowarek (%) [na EV = ",
        ratioOfHigh2: " kVa]",
        ratioOfBEV: "Stosunek pojazdów BEV do PHEV (%)",
        confidenceLevel: "Poziom ufności % (rozkład dwumianowy)",
        percentageOfPeopleWhoPurchase: "Procent osób, które kupują nowy samochód rocznie (%)",
        modifyProbalities: "Modyfikuj prawdopodobieństwa",
        changeProbabilityDistribution: "Zmień rozkład prawdopodobieństwa",
      },
      charts: {
        evForecast: {
          title: "Przewidywany odsetek sprzedaży samochodów elektrycznych rocznie (do 2030 roku)",
          label: "Prognoza sprzedaży samochodów elektrycznych",
          xAxis: "Rok",
          yAxis: "% Samochodów elektrycznych",
          vAxes: {
            title: "% Samochodów elektrycznych",
          },
          hAxis: {
            title: "Rok",
          },
        },
        cumulProbChart: {
          title: "Prawdopodobieństwo, że ładowarka EV będzie pobierać energię w ciągu godziny",
          label: "Analiza prawdopodobieństwa skumulowanego",
          xAxis: "Godzina dnia",
          yAxis: "Prawdopodobieństwo ładowania",
          vAxes: {
            title: "Prawdopodobieństwo ładowania",
          },
          chartLabels: {
            0: "Oznaczenie czasowe",
            1: "Prawdopodobieństwo ładowania (%)",
          },
        },
        powerLoadDataOnly: {
          title: {
            1: "Analiza obciążenia transformatora / marginesu [ ",
            2: " ]",
          },
          label: "Obciążenie transformatora",
          yLabel: "Godzina dnia",
          xLabel: "Obciążenie (kVa)",
          vAxes: {
            0: { title: "Obciążenie (kVa)" },
            1: { title: "Margines (kVa)" },
          },
          chartLabels: {
            0: { title: "Godzina dnia" },
            1: { title: "Całkowite obciążenie" },
            2: { title: "Margines" },
            3: { title: "Maks. obciążenie" },
          },
        },
        evModelChart: {
          title: "Maksymalna liczba dodatkowych ładowarek EV dla tego transformatora (analiza rozkładu dwumianowego)",
          label: "Analiza dostępności ładowarek EV",
          xAxis: "Godzina dnia",
          yAxis: "# Ładowarek EV",
          vAxes: {
            0: { title: "# Ładowarek EV" },
            1: { title: "MAX_EVS = " },
          },
          chartLabels: {
            0: { title: "Oznaczenie czasowe" },
            1: { title: "Maksymalna liczba ładowarek" },
            2: { title: "Maksymalna liczba EV" },
          },
        },
        totalNewEVCharge: {
          title: "Przewidywana liczba nowych ładowarek EV rocznie dla tego transformatora",
          label: "Obliczona sprzedaż nowych EV rocznie",
          xAxis: "Rok",
          yAxis: "# Łączna liczba nowych ładowarek EV",
          vAxes: {
            title: "# Łączna liczba nowych ładowarek EV",
          },
          hAxis: {
            title: "Rok",
          },
          chartLabels: {
            0: { title: "Rok" },
            1: { title: "Liczba EV" },
            2: { title: "Pierwszy rok powyżej pojemności" },
          },
        },
      },
    },
    FleetReport: {},
    Hero: {},
    HomeContent: {},
    HPModelEditDetails: {
      filters: {
        modelName: {
          label: "Wybierz model",
        },
        dayType: {
          label: "Wybierz typ dnia",
          tooltip: "Wybierz najnowszy dzień lub najgorszy dzień obciążenia w roku",
          mostRecentWeekday: "Najnowszy dzień roboczy",
          maxAnnualLoadDay: "Maksymalny dzień obciążenia rocznego",
          mostRecentWeekdayTooltip: "* Dla których dostępne są dane wiadomości z 24 godzin",
        },
        extremeScenerio: {
          label: "Ekstremalny scenariusz ('1 na 20')",
          tooltip: "Modele dla niezwykle zimowego 'szczytu zimowego' (np. -5 stopni Celsjusza)",
        },
      },
      title: "Szczegóły modelu HP",
      subTitle: "Nazwa modelu",
      HPModelEdit: {
        labels: {
          chooseModelName: "Wybierz nazwę modelu",
          ratioOfNewBuildExistingHomes: {
            title: "Stosunek nowo wybudowanych domów do istniejących (%)",
            labelA: "Nowo wybudowane",
            labelB: "Istniejące",
          },
          ratioOfDetachedvsSemi: {
            title: "Stosunek domów jednorodzinnych do domów bliźniaczych lub szeregowych (%)",
            labelA: "Jednorodzinne",
            labelB: "Bliźniacze/szeregowe",
          },
          ratioOfHybridvsAir: {
            title: "Stosunek pomp ciepła hybrydowych do pomp powietrznych (%)",
            labelA: "Hybrydowe",
            labelB: "ASHP",
          },
          ratioOfHighTemp: {
            title: "Stosunek pomp powietrznych o wysokiej temperaturze (HT) do niskiej temperatury (LT) (%)",
            labelA: "HT",
            labelB: "LT",
          },
          percentageOfPeopleWhoInstall: {
            title: "Procent osób, które instalują pompę ciepła rocznie (%)",
            labelA: "Prawdopodobieństwo",
          },
        },
      },
      charts: {
        loadProfiles: {
          title: "Przykładowe profile obciążenia pomp ciepła na dom i typ pompy ciepła",
          label: "Profile obciążenia pomp ciepła",
          xAxis: "Godzina dnia",
          yAxis: "Obciążenie pomp ciepła (kW)",
          vAxes: {
            0: { title: "Obciążenie pomp ciepła (kW)" },
          },
        },
        HPLoadChart: {
          title: "Szacowany profil obciążenia pomp ciepła na model",
          label: "Analiza obciążenia pomp ciepła",
          xAxis: "Godzina dnia",
          yAxis: "Obciążenie pomp ciepła (kVA)",
          vAxes: {
            0: { title: "Obciążenie pomp ciepła (kVA)" },
          },
          labelA: "Oznaczenie czasowe",
          labelB: "Obciążenie pomp ciepła (kVa)",
        },
        powerModel: {
          title: {
            0: "Analiza obciążenia transformatora / rezerwy [",
            1: " ]",
          },
          label: "Obciążenie transformatora",
          xAxis: "Godzina dnia",
          yAxis: "Obciążenie (kVa)",
          data: {
            0: "Oznaczenie czasowe",
            1: "Obciążenie (kVa)",
          },
          vAxes: {
            0: { title: "Obciążenie (kVa)" },
            1: { title: "Rezerwa (kVa)" },
          },
          labelA: "Godzina dnia",
          labelB: "Całkowite obciążenie",
          labelC: "Rezerwa",
        },
        HPModel: {
          title: "Maksymalna liczba dodatkowych pomp ciepła na tym transformatorze",
          label: "Analiza dostępności pomp ciepła",
          xAxis: "Godzina dnia",
          yAxis: "# Pomp Ciepła",
          vAxes: {
            0: { title: "# Pomp Ciepła" },
            1: { title: "MAX_HPS = " },
          },
          labelA: "Oznaczenie czasowe",
          labelB: "Maksymalna liczba pomp ciepła",
        },
        HPCalculatedSales: {
          title: "Przewidywana liczba nowych pomp ciepła rocznie na tym transformatorze",
          label: "Obliczona roczna sprzedaż pomp ciepła",
          xAxis: "Rok",
          yAxis: "# Łączna liczba nowych pomp ciepła",
          vAxes: {
            0: { title: "# Łączna liczba nowych pomp ciepła" },
          },
          hAxis: {
            title: "Rok",
          },
          labelA: "Rok",
          labelB: "Liczba pomp ciepła",
        },
      },
    },
    InputSelectVT: {},
    KPIReport: {},
    LineChart: {},
    LineChartVT: {},
    LoaderVT: {},
    MapInfoWindow: {},
    MapInfoWindowPowerdataTemplate: {},
    MapInfoWindowTemplate: {},
    MapMarkerVT: {},
    MapsVT: {},
    MapTooltipVT: {},
    MinMaxChart: {},
    NavBar: {},
    OverviewCardsVT: {},
    PageHeader: {},
    POISnapshot: {},
    PowerDataMainReport: {
      title: "Oto dzisiejszy raport od VT Electron",
      tables: {
        fleetStatus: {
          title: "Status Floty",
          columns: {
            issue: {
              text: "Problem",
            },
            numberOfAssets: {
              text: "Liczba urządzeń",
            },
            percentageDevices: {
              text: "%",
            },
          },
        },
        devices: {
          columns: {
            name: {
              text: "Nazwa",
            },
            transformerSize: {
              text: "Rozmiar transformatora",
            },
            maxCapacity: {
              text: "Maksymalna pojemność",
            },
            maxCurrent: {
              text: "Maksymalny prąd PH1-PH2-PH3",
            },
            maxTemperature: {
              text: "Maksymalna temperatura",
            },
            graph: {
              text: "",
            },
          },
        },
      },
    },
    PrimaryFiltersVT: {},
    RadialChartVT: {},
    ReportManagement: {},
    ScavengerCharts: {},
    SecondaryFiltersVT: {},
    SelectVT: {},
    SnackBarVT: {},
    TooltipVT: {},
  },
};
